import { apiClient } from "../../base/ApiClient";

export const getAlerts = async (page, location) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (location) params.append("location", location);
  const response = await apiClient.get(
    `/notification/notifications/?${params.toString()}`
  );
  return response.data;
};

export const patchAlert = async (id, data) => {
  const response = await apiClient.patch(
    `/notification/notifications/${id}/`,
    data
  );
  return response;
};

export const markNotificationRead = async (id) => {
  const response = await apiClient.patch(
    `/notification/notifications/${id}/mark-read/`
  );
  return response;
};

export const markNotificationUnread = async (id) => {
  const response = await apiClient.patch(
    `/notification/notifications/${id}/mark-unread/`
  );
  return response;
};

export const acknowledgeNotification = async (id) => {
  const response = await apiClient.patch(
    `/notification/notifications/${id}/acknowledge/`
  );
  return response;
};

export const markAllNotificationsRead = async () => {
  const response = await apiClient.patch(
    `/notification/notifications/mark-all-read/`
  );
  return response;
};

export const deleteAlert = async (id) => {
  const response = await apiClient.delete(`/notification/notifications/${id}/`);
  return response;
};

export const getActionJobs = async (page, location) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (location) params.append("location", location);
  const response = await apiClient.get(
    `/notification/action-jobs/?${params.toString()}`
  );
  return response.data;
};

export const getDolsList = async (page, location) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (location) params.append("location", location);
  const response = await apiClient.get(
    `/client/dols/list/?${params.toString()}`
  );
  return response.data;
};

export const getActionIssuesJobs = async (page, location) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (location) params.append("location", location);
  const response = await apiClient.get(
    `/notification/action-issues/?${params.toString()}`
  );
  return response.data;
};

export const getHandovers = async (page, location) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (location) params.append("location", location);
  const response = await apiClient.get(
    `/notification/handover/?${params.toString()}`
  );
  return response.data;
};

export const getWeightsChart = async (page, location) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (location) params.append("location", location);
  const response = await apiClient.get(
    `/observations/weights/?${params.toString()}`
  );
  return response.data;
};

export const getHealthAssesments = async (page, assessment_type, location) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (assessment_type) params.append("assessment_type", assessment_type);
  if (location) params.append("location", location);
  const response = await apiClient.get(
    `/observations/assessments/?${params.toString()}`
  );
  return response.data;
};

export const getSecondaryAssesments = async (
  page,
  assessment_type,
  location
) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (assessment_type) params.append("assessment_type", assessment_type);
  if (location) params.append("location", location);
  const response = await apiClient.get(
    `/observations/secondary-assessments/?${params.toString()}`
  );
  return response.data;
};

export const getVisitCarePlans = async (page, location) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (location) params.append("location", location);
  const response = await apiClient.get(
    `/core/visit_careplans?${params.toString()}`
  );
  return response.data;
};

export const getTodaysBirthday = async () => {
  const response = await apiClient.get(`/notification/todays-birthday/`);
  return response.data;
};

export const getTodaysTeam = async () => {
  const response = await apiClient.get(`/notification/todays-team/`);
  return response.data;
};

export const getTodaysProgress = async () => {
  const response = await apiClient.get(`/notification/todays-progress/`);
  return response.data;
};

export const getIncidetsList = async (page, location) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (location) params.append("location", location);
  const response = await apiClient.get(
    `/notification/incidents/?${params.toString()}`
  );
  return response.data;
};

export const getIncidentDetails = async (id) => {
  const response = await apiClient.get(`/notification/incidents/${id}/`);
  return response.data;
};

export const updateIncident = async (id, data) => {
  const response = await apiClient.patch(
    `/notification/incidents/${id}/`,
    data
  );
  return response;
};

export const createIncidentCommentary = async (incident_id, data) => {
  const response = await apiClient.post(
    `/notification/${incident_id}/incident-commentary/`,
    data
  );
  return response;
};

export const getRecordAbsense = async (location) => {
  const params = new URLSearchParams();

  if (location) params.append("location", location);
  const response = await apiClient.get(
    `/client/record-absences/?${params.toString()}`
  );
  return response.data;
};

export const getAllNotifications = async (page) => {
  const params = new URLSearchParams();
  if (page) params.append("page", page);
  const response = await apiClient.get(
    `/notification/notifications/?${params.toString()}`
  );
  return response.data;
};